import { Button, Text } from "components/commons";
import styles from "../cash-noncash.module.scss";
import { formatAmount, formatDecimal, formatVolume } from "utils";
import { prettifyPaymentMethod } from "utils/pretty.utils";
import { PaymentMethod } from "enums";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { formatPumpNumber } from "utils/text.utils";

export const nonCashSummaryMapper = ({
  val,
  onViewPaymentMethodTransaction,
  nonCashTransactions = [],
  transactionsItemDetails = [],
}) => {
  let {
    transactionCount,
    method,
    excessAmount,
    // transactions: paymentMethodsTransactions,
    discount,
    // amountPaid,
    totalAmount,
    finalAmount,
    // transactions,
  } = val;
  const paymentMethod =
    prettifyPaymentMethod(method) +
    ([PaymentMethod.GiftCard, PaymentMethod.Other].includes(method) ? "s" : "");

  // const totalAmount = transactions.reduce((acc, transaction) => {
  //   return acc + transaction.totalAmount;
  // }, 0);

  return {
    method: <Text className={styles.content}>{paymentMethod}</Text>,
    transactionCount: <Text className={styles.content}>{transactionCount}</Text>,
    totalAmount: <Text className={styles.content}>{formatAmount(totalAmount)}</Text>,
    discount: (
      <Text className={discount < 0 ? styles.negative : styles.content}>
        {`${discount < 0 ? "-" : ""}${formatAmount(discount)}`}
      </Text>
    ),
    finalAmount: (
      <>
        <Text className={styles.content}>{formatAmount(finalAmount)}</Text>
        <Text className={styles.subcontent}>
          {isNaN(excessAmount) || excessAmount < 0.005
            ? ""
            : `Excess: ${formatAmount(excessAmount)}`}
        </Text>
      </>
    ),
    actions: (
      <Button
        style={{ textDecoration: "none" }}
        link
        onClick={() => onViewPaymentMethodTransaction(method)}
      >
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>View</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};

export const nonCashTransactionMapper = ({
  val,
  transactionsItemDetails = [],
  initialState,
  method,
  onRefetch,
  pageMode,
}) => {
  const {
    // finalAmountPaid,
    // excessAmountPaid,
    // displayExcessAmount,
    transaction,
    // totalAmount,
    // totalDiscount,
  } = getCashAndNonCashTotals({
    payment: val,
    transactionsItemDetails,
  });
  let {
    quantity,
    type,
    name,
    transactionNumber,
    refNumber,
    pumpNumber,
    refName,
    plateNumber,
    remarks,
    transactionPaymentMethodId,
    totalAmount,
    discount,
    finalAmount,
    // Values from enriched data for formula calculation
    // productAmount,
    // productDiscount,
    // transactionTotalAmount,
    // paymentMethodAmount,
  } = val;

  // Calculate the ratio: (amount of payment method) / (total amount of transaction)
  // const paymentRatio =
  //   transactionTotalAmount > 0 ? paymentMethodAmount / transactionTotalAmount : 0;

  // Helper function for rounding
  // const roundTo2Decimals = (value) => Math.round(value * 100) / 100;

  // // Discount/Premium - productDiscount is already the proportional discount value from the transaction
  // const calculatedDiscount = roundTo2Decimals(productDiscount || 0);

  // // Check if this is a Gift Card payment method
  // const isGiftCard = method === PaymentMethod.GiftCard;

  // let calculatedAmount;
  // let calculatedFinalAmountPaid;

  // if (isGiftCard) {
  //   // For Gift Cards: use direct paymentMethodAmount as Final Amount Paid
  //   // Amount = Final Amount Paid + Discount (the original amount before discount was applied)
  //   calculatedFinalAmountPaid = roundTo2Decimals(paymentMethodAmount || 0);
  //   calculatedAmount = roundTo2Decimals(calculatedFinalAmountPaid + calculatedDiscount);
  // } else {
  //   // For other payment methods (split payments, etc.): use ratio formula
  //   // Amount = (amount of payment method) / (total amount of transaction) * (amount of product)
  //   calculatedAmount = roundTo2Decimals(paymentRatio * (productAmount || 0));
  //   // Final Amount Paid = Amount - Discount
  //   calculatedFinalAmountPaid = roundTo2Decimals(calculatedAmount - calculatedDiscount);
  // }

  // const isFuel = type === "fuel";

  const resultTotalAmount = totalAmount;
  const resultFinalAmount = finalAmount;

  let reference = refName;
  if (reference === "") {
    reference = "--";
  }

  let plateNum = plateNumber;
  if (plateNum === "") {
    plateNum = "--";
  }

  let quantityFormat = type === "fuel" ? formatVolume(quantity ?? 0) : formatDecimal(quantity, 2);

  // Use transactionPaymentMethodId directly from val (enriched data) or fallback to finding it
  let finalTransactionPaymentMethodId = transactionPaymentMethodId;
  if (!finalTransactionPaymentMethodId) {
    const paymentMethods = transaction?.paymentMethods || [];
    const paymentMethodRecord = paymentMethods.find((pm) => pm.refNumber === refNumber);
    finalTransactionPaymentMethodId = paymentMethodRecord?.transactionPaymentMethodId;
  }

  return {
    paymentMethod: (
      <>
        <Text className={styles.content}>{refNumber}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(resultTotalAmount)}</Text>
      </>
    ),
    discount: (
      <>
        <Text className={discount < 0 ? styles.negative : styles.content}>
          {`${discount < 0 ? "-" : ""}${formatAmount(discount)}`}
        </Text>
      </>
    ),
    finalAmount: (
      <>
        <Text className={styles.content}>{formatAmount(resultFinalAmount)}</Text>
        {/* <Text className={styles.subcontent}>
          {excessAmount < 0.005 ? "" : `Excess: ${formatAmount(excessAmount)}`}
        </Text> */}
      </>
    ),
    transactionId: (
      <>
        <Text className={styles.content}>{transactionNumber ?? "--"}</Text>
      </>
    ),
    product: (
      <>
        <Text className={styles.content}>{name ?? "--"}</Text>
      </>
    ),
    pumpNumber: (
      <>
        <Text className={styles.content}>
          {type === "fuel" ? formatPumpNumber(pumpNumber.split(",")[0]) : "--"}
        </Text>
      </>
    ),
    quantity: (
      <>
        <Text className={styles.content}>{quantityFormat}</Text>
      </>
    ),
    refName: (
      <>
        <Text className={styles.content}>{reference ?? "--"}</Text>
        <Text className={styles.content}>{plateNum ?? "--"}</Text>
      </>
    ),
    remarks: (
      <>
        <Text className={styles.content}>{remarks ?? (transaction?.remarks || "--")}</Text>
      </>
    ),
  };
};

export const getCashAndNonCashTotals = ({ payment, transactionsItemDetails, isNonCash = true }) => {
  let {
    sku,
    discount,
    totalAmount,
    discountPremium,
    vat,
    amountPaid,
    transactionId,
    excessAmount,
  } = payment;

  let transactionDetails = transactionsItemDetails.find(
    (t) => t.transactionId === transactionId && t.sku === sku,
  );

  if (!transactionDetails) {
    transactionDetails = transactionsItemDetails.find((t) => t.transactionId === transactionId);
  }

  const mAmount = totalAmount - excessAmount;
  const mActualDiscount = mAmount - amountPaid;
  let isDiscountCorrect = false;

  const roundedWith2DecimalPlaces = (value) => {
    return Math.round(value * 100) / 100;
  };

  if (roundedWith2DecimalPlaces(mActualDiscount) === roundedWith2DecimalPlaces(discount)) {
    isDiscountCorrect = true;
  } else {
    isDiscountCorrect = false;
  }

  let mDiscountPremium = 0;
  if (vat === 0 && totalAmount < amountPaid) {
    const mVat = (totalAmount * 12) / 112;
    if (isDiscountCorrect) {
      mDiscountPremium = -discount;
    } else {
      mDiscountPremium = -discount - mVat;
    }
  } else {
    mDiscountPremium = -discount;
  }

  const mFinalAmount = mAmount + mDiscountPremium;

  const finalTotalAmount = mAmount; // as "Amount" Column
  const totalDiscount = mDiscountPremium; // as "Discount/Premium" Column
  const finalAmountPaid = mFinalAmount; // as "Final Amount Paid" Column

  const amount = finalTotalAmount - (discount ?? 0) + (discountPremium ?? 0);
  const excessAmountPaid = amountPaid > amount ? amountPaid - amount : 0;
  const hasDiscount = discount >= 0.01;

  // distribute excess amount
  const share = (finalAmountPaid / transactionDetails?.transaction?.amount) * excessAmount;
  const displayExcessAmount =
    transactionDetails?.transaction?.excessAmount > 0 &&
    transactionDetails?.transaction?.excessAmount === excessAmount
      ? share
      : excessAmount;

  return {
    payment,
    finalAmountPaid,
    excessAmountPaid,
    transaction: transactionDetails?.transaction,
    totalDiscount: Math.abs(totalDiscount),
    displayExcessAmount,
    hasDiscount,
    totalAmount: finalTotalAmount,
    shiftId: transactionDetails?.shiftId,
  };
};
